import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { ChevronDown } from 'lucide-react';
interface FaqItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}
function FaqItem({
  question,
  answer,
  isOpen,
  onToggle
}: FaqItemProps) {
  return <div className="border-b border-charcoal/10 last:border-b-0" data-id="element-43">
      <button onClick={onToggle} className="w-full flex items-start justify-between py-6 text-left gap-4" data-id="element-44">
        <span className="font-heading text-lg md:text-xl text-charcoal" data-id="element-45">
          {question}
        </span>
        <ChevronDown className={`w-5 h-5 text-gold-dark flex-shrink-0 mt-1 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-46" />
      </button>
      <div className={`overflow-hidden transition-all duration-400 ease-in-out ${isOpen ? 'max-h-96 pb-6' : 'max-h-0'}`} data-id="element-47">
        <p className="font-body text-charcoal/70 leading-relaxed pr-10" data-id="element-48">
          {answer}
        </p>
      </div>
    </div>;
}
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿Esto reemplaza la terapia psicológica?',
    answer: 'No. Este sistema no reemplaza un proceso terapéutico profesional. Pero puede ayudarte a entender patrones que muchas veces la terapia no logra hacer visibles con claridad.'
  }, {
    question: '¿Cuánto tiempo necesito para ver resultados?',
    answer: 'Desde el primer ejercicio puedes tener un "clic" importante. Muchas personas identifican su patrón en menos de 30 minutos.'
  }, {
    question: '¿Y si no entiendo nada o no me funciona?',
    answer: 'Por eso tienes una garantía de 7 días. Puedes entrar, explorar el sistema y decidir con total tranquilidad.'
  }, {
    question: '¿Necesito experiencia previa en terapia o sanación?',
    answer: 'No. Todo está diseñado paso a paso, de forma simple y guiada.'
  }, {
    question: '¿Esto es para mí si ya hice terapia antes?',
    answer: 'Sí. De hecho, muchas personas llegan después de haber probado otras herramientas y encuentran aquí una explicación más profunda.'
  }, {
    question: 'Tengo miedo de lo que pueda encontrar, ¿es normal?',
    answer: 'Sí. Es completamente normal. Pero este proceso no busca abrumarte, sino ayudarte a entender desde un lugar seguro.'
  }, {
    question: '¿Cómo recibo el contenido?',
    answer: 'Acceso inmediato después del pago. Podrás entrar al sistema y comenzar en el momento.'
  }];
  return <section className="py-24 bg-beige-light relative" data-id="element-49">
      <div className="container mx-auto px-6 max-w-3xl" data-id="element-50">
        <FadeIn className="text-center mb-16" data-id="element-51">
          <h2 className="font-heading text-4xl text-charcoal mb-4" data-id="element-52">
            Preguntas frecuentes
          </h2>
          <div className="w-16 h-[1px] bg-gold mx-auto" data-id="element-53" />
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-54">
          <div className="bg-white rounded-sm shadow-sm border border-beige-dark p-6 md:p-10" data-id="element-55">
            {faqs.map((faq, index) => <FaqItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onToggle={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-56" />)}
          </div>
        </FadeIn>
      </div>
    </section>;
}